import { useMutation, UseMutationOptions } from 'react-query';
import { mutateVoidMatch } from './voidMatch';
import { TVoidMatchBody } from './voidMatch.types';

export const useMutationVoidMatch = (
  options?: UseMutationOptions<unknown, unknown, TVoidMatchBody>
) => useMutation((data) => mutateVoidMatch(data), options);
